import {GET_AVAILABILITY_STARTED} from "../../../reducers/availabilityReducer";


export const getAvailabilityStarted = () =>{
    return {
        type: GET_AVAILABILITY_STARTED,
        payload: {}
    }
}